module.exports = __webpack_public_path__ + "img/en-US.a86b2cd.png";